import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";

const restLink_dam = new HttpLink({
  uri: "/api/v1/dam/",
  credentials: "include",
});
const dam_client = new ApolloClient({
  link: restLink_dam,
  cache: new InMemoryCache(),
});

const restLink_lms = new HttpLink({
  credentials: "include",
  uri: "/api/v1/lms/",
});
const lms_client = new ApolloClient({
  link: restLink_lms,
  cache: new InMemoryCache(),
});

const GET_TRAIL = gql`
  query getTrails($category_id: Int!) {
    trails_collections(category_id: $category_id) {
      trails {
        id
        title
        thumbnail
      }
    }
  }
`;

const GET_TRAILITEMS = gql`
  query getItens($trail_id: Int!) {
    trailitems(trail_id: $trail_id) {
      trailitems {
        item_id
        item_type
      }
    }
  }
`;

const GET_CURSE = gql`
  query getCourse($course_id: Int!) {
    course(id: $course_id) {
      id
      title
      thumbnail
    }
  }
`;

const GET_ASSET = gql`
  query getAsset($dam_id: Int!) {
    asset(id: $dam_id) {
      id
      title
      thumbnail
    }
  }
`;

const GET_TRAIL_HAS_USER_ITEM = gql`
  query trail_has_user_item($trail_id: Int!, $category_id: Int!) {
    trail_has_user_item(trail_id: $trail_id, category_id: $category_id) {
      id
      status
      blocked
    }
  }
`;

class TrailList extends Component {
  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }
  render() {
    const windowWidth = window.innerWidth;

    var settings_courses = {
      autoplay: false,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: windowWidth <= 987 ? 2 : 4,
      slidesToScroll: windowWidth <= 987 ? 2 : 4,
    };
    return (
      <div>
        <div>
          <p>
            <strong>AVISO:</strong>
          </p>
          <p>
            As três primeiras trilhas devem ser assistidas na seqüencia de
            apresentação.
          </p>
          <p>
            Após finalizar na íntegra estas 3 trilhas iniciais, todas as demais
            serão desbloqueadas automaticamente para que possa assistí-las de
            acordo com o seu interesse.
          </p>
        </div>
        <Query
          client={lms_client}
          query={GET_TRAIL}
          variables={{ category_id: this.props.category_id }}
        >
          {({ loading, error, data }) => {
            if (loading)
              return (
                <tr>
                  <td>Carregando...</td>
                </tr>
              );
            if (error)
              return (
                <tr>
                  <td>Erro 1:(</td>
                </tr>
              );

            var trail_by_rows = [];
            var i = 1;
            var ii = 1;
            data.trails_collections.trails.map((item) => {
              if (!trail_by_rows[i]) {
                trail_by_rows[i] = [];
              }
              trail_by_rows[i].push(item);
              if (ii++ === 3) {
                ii = 1;
                i++;
              }
            });

            var itens_finalized = [];

            return trail_by_rows.map((items_trail) => (
              <Row>
                {items_trail.map((item_trail) => (
                  <Col md={12}>
                    <Query
                      client={lms_client}
                      variables={{ trail_id: item_trail.id }}
                      query={GET_TRAILITEMS}
                    >
                      {({ loading, error, data }) => {
                        if (loading)
                          return (
                            <tr>
                              <td>Carregando...</td>
                            </tr>
                          );
                        if (error)
                          return (
                            <tr>
                              <td>Erro :(</td>
                            </tr>
                          );

                        const item = data.trailitems.trailitems[0];
                        if (!item) {
                          return <div></div>;
                        }

                        return (
                          <Query
                            client={lms_client}
                            variables={{
                              trail_id: item_trail.id,
                              category_id: this.props.category_id,
                            }}
                            query={GET_TRAIL_HAS_USER_ITEM}
                            fetchPolicy="no-cache"
                          >
                            {({ loading, error, data }) => {
                              if (loading) return <div></div>;
                              if (error) return <div></div>;

                              if (
                                data.trail_has_user_item !== null &&
                                data.trail_has_user_item.status === "finalized"
                              ) {
                                itens_finalized.push(item_trail.id);
                              }

                              return (
                                <div>
                                  <div
                                    key={item_trail.id}
                                    className="course-item"
                                  >
                                    <a
                                      data-gtm-type="click"
                                      data-gtm-clicktype="card"
                                      data-gtm-name={item_trail.title}
                                      href={
                                        !data.trail_has_user_item.blocked
                                          ? "/#/trail/" + item_trail.id
                                          : false
                                      }
                                      onClick={
                                        data.trail_has_user_item.blocked
                                          ? () => {
                                              alert(
                                                "Para desbloqueio faz-se necessário assitir à(s) trilha(s) anterior(es)"
                                              );
                                            }
                                          : ""
                                      }
                                    >
                                      <img
                                        src={
                                          "/lms/assets/" + item_trail.thumbnail
                                        }
                                      />

                                      {data.trail_has_user_item.blocked ? (
                                        <div className="is_viewed">
                                          Bloqueado
                                        </div>
                                      ) : (
                                        <div>
                                          {data.trail_has_user_item &&
                                          data.trail_has_user_item.status ===
                                            "finalized" ? (
                                            <div className="is_viewed">
                                              Concluído
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {data.trail_has_user_item &&
                                          data.trail_has_user_item.status ===
                                            "started" ? (
                                            <div className="is_viewed">
                                              Iniciado
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      )}
                                    </a>
                                  </div>
                                </div>
                              );
                            }}
                          </Query>
                        );
                      }}
                    </Query>
                  </Col>
                ))}
              </Row>
            ));
          }}
        </Query>
      </div>
    );
  }
}

export default TrailList;



// WEBPACK FOOTER //
// ./src/components/Trail/List.jsx